import script from "./ReviewResult.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewResult.vue?vue&type=script&setup=true&lang=js"

import "./ReviewResult.vue?vue&type=style&index=0&id=8d57c816&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d57c816"]])

export default __exports__